// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"e4329e05","453":"03346f77","877":"cf4a77bf","954":"e0842b7d"}[chunkId] + ".chunk.js";
};